/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PoolingReportArrayResponse } from '../../models/pooling-report-array-response';
import { PoolingReportRequest } from '../../models/pooling-report-request';

export interface GetPoolingReport$Params {
  organizationSiteKey: KeyType;
      body: PoolingReportRequest
}

export function getPoolingReport(http: HttpClient, rootUrl: string, params: GetPoolingReport$Params, context?: HttpContext): Observable<StrictHttpResponse<PoolingReportArrayResponse>> {
  const rb = new RequestBuilder(rootUrl, getPoolingReport.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PoolingReportArrayResponse>;
    })
  );
}

getPoolingReport.PATH = '/pooling/organization-sites/{organizationSiteKey}/report';
